var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-create-layout',[_c('challenges-form',{attrs:{"parentId":_vm.parentId,"parentClientId":_vm.clientId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }